















import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import UiBadgeComponent from '@/app/shared/components/ui/ui-badge-component.vue';

@Component({
  components: {
    UiBadgeComponent
  }
})
export default class ToastNotificationComponent extends Vue {
  @Prop()
  public title: string;

  @Prop()
  public message: string;

  @Prop({
    default: 'general'
  })
  public type: string;

  @Prop({
    default: true
  })
  public closable: boolean;

  @Prop({
    default: true
  })
  public visible: boolean;

  @Prop({
    default: ''
  })
  public badgeName: string;

  @Prop({ default: 'show' })
  public phase: 'show' | 'hide'

  @Prop({
    default: null
  })
  public imageUri: string|null;

  private slideIn: boolean = true;

  private fadeOut: boolean = false;

  @Watch('phase')
  private watchPhase() {
    if (this.phase === 'hide') {
      this.hideNotification()
    }
  }

  private hideNotification(): void {
    this.slideIn = false;
    this.fadeOut = true;
    const self = this;
  }

  @Emit('close')
  private emitClose(): void {
  }
}
